import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-responsible-gambling-section',
  templateUrl: './responsible-gambling-section.component.html',
  styleUrls: ['./responsible-gambling-section.component.scss']
})
export class ResponsibleGamblingSectionComponent {
  constructor(private router: Router) {}

  goToResponsibleGamblingPage(): void {
    this.router.navigate(['/responsible-gambling']);
  }
}

